import {combineReducers} from '@reduxjs/toolkit';
// import { reducer as formReducer } from 'redux-form';
import accountReducer from './accountReducer';

import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
  // sidebarShow: false//'responsive'
  sidebarShow: false
}

// const changeState = (state = initialState, {type, ...rest}) => {
const changeState = (state = initialState, {type, ...rest}) => {
  switch (type) {
    case 'set':
      return {...state, ...rest}
    default:
      return state
  }
}

const reducers = combineReducers({
  account: persistReducer({
    key: 'account', storage, keyPrefix: 'GalileoSpace-'
  }, accountReducer), sidebarShow: changeState, // form: formReducer
});

export default reducers;
